import React, {Component} from 'react';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Table
} from 'reactstrap';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import Loader from '../../Loader';
import Sanitize from '../../Sanitize';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import MessagePage from '../../views/MessagePage/';
const GLOBAL = require('../../Globals');

class SMSlog extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			ckdate : (new Date().getFullYear())+'-'+(this.addzero(new Date().getMonth()+1))+'-'+(this.addzero(new Date().getDate())),
			posts: [],
			postFilter : [],
			_redirect : false,
			_redirectView : false,
			loading: false,
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			stdname : '',
			staname : '',
			stdregno : '',
			usename : '',
			stdmobno : '',
			clas : [],
			users : [],
			rowdata : [],
			purp : '',
			cls : '',
			section : ''
		}
		this.basestate = this.state;
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.onPurposeChange = this.onPurposeChange.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSecChange = this.onSecChange.bind(this);
		this.onUserChange = this.onUserChange.bind(this);
		this.onChange = this.onChange.bind(this);
	}
	
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
		//this.getdata();
		this.filterdata();
	}
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
		console.log(this.state);
		if(this.state == this.basestate){
			this.getusers();
			this.getdata();
		}
	}
	
	
	onDateChange(e){
	
		this.state.ckdate = e.target.value;
		console.log(this.state);
		this.getdata();
		this.filterdata();
	}
	
	onClassChange(e){
		
		this.state.cls = e.target.value;
		this.filterdata();
	}
	
	onSecChange(e){
		
		this.state.section = e.target.value;
		this.filterdata();
	}

	
	
	onPurposeChange(e){
		
		this.state.purp = e.target.value;
		this.filterdata();
		
	}
	
	onUserChange(e){
		
		this.state.usename = e.target.value;
		this.filterdata();
		
	}
	
	onMobChange(e){
		
		this.state.stdmobno = e.target.value;
		this.filterdata();
	}
	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
			
	addzero(day){
		
		var temp = ''+day;
		if(temp.length == 1){

		temp = "0"+temp;
		return temp;
		}
		else{

		return temp;
		}

	}
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdata();
		this.getusers();
		this.getrowtypes();
		this.getclass();
		console.log(this.state);
	}
	
	getdata(){
		this.setState({loading:true});
		this.setState({posts : []});
		$("#showLoader").show();
		GetData('message/getsmslogs/'+this.state.ckdate).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					postFilter : responseJson,
					loading:false
				});
				$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	/** get SMS rowtypes **/
	getrowtypes(){
		
		GetData('message/getsmspurposelogs/').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					rowdata : responseJson
				});
			}
		});
	}
	
	/** get Users **/
	getusers(){
		
		GetData('message/getusers/').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					users : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		GetData('message/getclassbyacyear/').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					clas : responseJson
				});
			}
		});
	}
	
	filterdata(){
		
		this.state.postFilter = [];
		var dat = [];
		for(var i=0; i<this.state.posts.length; i++){
			
			if(this.state.cls!='' && this.state.section == ''){
				
				if(this.state.posts[i].class == this.state.cls){
					
					dat.push(this.state.posts[i]);
				}
			}
			else if(this.state.cls!='' && this.state.section!=''){
				
				if(this.state.posts[i].class == this.state.cls && this.state.posts[i].section == this.state.section){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.usename!='' && this.state.purp =='' && this.state.ckdate ==''){
				
				if(this.state.posts[i].userid == this.state.usename){
					
					dat.push(this.state.posts[i]);
				}
			}
			else if(this.state.purp!='' && this.state.usename =='' && this.state.ckdate ==''){
				
				if(this.state.posts[i].reason == this.state.purp){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.usename!='' && this.state.purp!='' && this.state.ckdate ==''){
				
				if(this.state.posts[i].userid == this.state.usename && this.state.posts[i].reason == this.state.purp){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.ckdate!='' && this.state.usename =='' && this.state.purp ==''){
				
				if(this.state.posts[i].send_date == this.state.ckdate){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.ckdate!='' && this.state.usename !='' && this.state.purp ==''){
				
				if(this.state.posts[i].send_date == this.state.ckdate && this.state.posts[i].userid == this.state.usename){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.ckdate!='' && this.state.usename =='' && this.state.purp !=''){
				
				if(this.state.posts[i].send_date == this.state.ckdate && this.state.posts[i].reason == this.state.purp){
					
					dat.push(this.state.posts[i]);
				}
			}
			
			else if(this.state.ckdate!='' && this.state.usename !='' && this.state.purp !=''){
				
				if(this.state.posts[i].send_date == this.state.ckdate && this.state.posts[i].userid == this.state.usename && this.state.posts[i].reason == this.state.purp){
					
					dat.push(this.state.posts[i]);
				}
			}
		}
		this.setState({postFilter : dat});
	}

	getSmsType(type){
		var txt = '';
		if(type == '1'){
			txt='SMS';
		}
		else if(type == '2'){
			txt='Push Notification';
		}
		else if(type == '3'){
			txt='Sms & Push Notification';
		}
		return txt;
	}
	
  render() {
	  
	  
	var items = this.state.clas;
    var purposes = this.state.rowdata;
	var user = this.state.users;
	
	/** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	
	function getdateofdt(date){
		      
		var date1 = new Date(date);
		var year = date1.getFullYear();
		var month = (date1.getMonth()+1);
		var day   = date1.getDate()
		var strTime = day + '-' + month + '-' + year;
		return strTime;
			
	}
	  
	function replacestr(str){
		
		var res = str.replace("groupsms_", "");
		return res
		
	}
	  
	$("#clas").change(function(){
		var fr = $(this).val();
		$.get(GLOBAL.BASE_URL+'message/getsecbyclass/'+fr,function(o){
			$("#secs").html('');
			$('#secs')
				.append($("<option></option>")
				.attr("value",'')
				.text(' -Select- ')); 
			$.each(o,function(key,value){			
				   $('#secs')
					.append($("<option></option>")
					.attr("value",value.section)
					.text(value.secs)); 	
										
			});	
			
		},'json');
	
	});
	
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.postFilter.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
			return <tr key = {item}>
				<td width="50" className="tablewidth">{i+1}</td>
				<td width="200">{item.employeeid != '0' ? item.employeename : item.username}</td>
				<td width="500">{item.reason == 'groupsms_class_multiple' ? item.classnames : item.classname}</td>
				<td width="100">{item.secname}</td>
				<td width="250">{getdateofdt(item.send_date)}</td>
				<td width="250">{item.send_time}</td>
				<td width="350">{item.msg}</td>
				<td width="200">{this.getSmsType(item.sendway)}</td>
				<td width="200">{Sanitize.replacepurpose(item.reason)}</td>
				<td width="150">{item.count != '0' ? item.count : 'Failed To sent'}</td>
			</tr>;
		
	});

    return (
		<div>
		  <MessagePage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
				   <Card>
					<CardHeader>
						<strong>SMS Log</strong>&nbsp;&nbsp;
							Class : &nbsp;&nbsp;
								<select name="cls" onChange={this.onClassChange} id="clas"> 
									<option value="">Select Class</option>
									{
										items.map(function (item) {
											return <option value={item.class }>{item.cls}</option>;
										})
									}
								</select>&nbsp;&nbsp;
							Section : &nbsp;&nbsp;
								<select name="section" onChange={this.onSecChange} id="secs">
												
								</select>&nbsp;&nbsp;
							User : &nbsp;&nbsp;
								<select name="usename" onChange={this.onUserChange}  >
									<option value="">Select User</option>
									{
										user.map(function (item) {
											return <option value={item.id }>{item.name}</option>;
										})
									}
								 </select>&nbsp;&nbsp;
							Category : &nbsp;&nbsp;
								<select name="purp" onChange={this.onPurposeChange} > 
									<option value="">Select Category</option>
									{
										purposes.map(function (item) {
											return <option value={item.reason }>{Sanitize.replacepurpose(item.reason)}</option>;
										})
									}
								</select>&nbsp;&nbsp;
							Date : &nbsp;&nbsp;
								<input type="date" name="ckdate" onChange={this.onDateChange} value={this.state.ckdate} />
								<br />
								<br />
							Total Reports : <span>{this.state.postFilter.length}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							 <ReactHTMLTableToExcel
								id="test-table-xls-button"
								className="download-table-xls-button btn-right"
								table="table-to-xls_report"
								filename="smslogreport"
								sheet="tablexls"
								Button size="xs"
								buttonText="Export"/>
					</CardHeader>
					<CardBody>
					  <Col md="12">
						<Table responsive striped id="table-to-xls_report">
						<thead>
							<tr>
								<th width="50" className="tablewidth">S.No</th>
								<th width="200">User Name</th>
								<th width="500">Class</th>
								<th width="100">Section</th>
								<th width="250">Send Date</th>
								<th width="250">Send Time</th>
								<th width="300">Message</th>
								<th width="200">SMS Type</th>
								<th width="200">Category</th>
								<th width="100">Count</th>
							</tr>
						</thead>
						<tbody>
							{this.state.loading ?  <tr><td colSpan="8"><center>{'No Data Found'}</center></td></tr> : renderTodos}
						</tbody>
					 </Table>
					 </Col>
					   <Col md="4">
					  <Pagination
							activePage={this.state.activePage}
							itemsCountPerPage={this.state.todosPerPage}
							pageRangeDisplayed={3}
							totalItemsCount={this.state.postFilter.length}
							onChange={this.handlePageChange}
						/>
					  </Col>
					  <Col md="2">
					   <select name="show" onChange={this.onShowChange} id="show" >
							{this.shows.map((e, key) => {
								return <option key={key} value={e.value}>{e.name}</option>;
							})}	
						</select>&nbsp;
						entries
					  </Col>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default SMSlog;


// WEBPACK FOOTER //
// ./src/message/SMSlog/SMSlog.js